// src/components/auth/GoogleAuthButton.tsx
import React, { useEffect } from 'react';
import { Button, useTheme } from '@mui/material'; // UPDATED: Import useTheme hook
import { useAppDispatch } from '../../app/hooks';
import { googleLoginUser } from '../../features/auth/authSlice';
import GoogleIconSvg from './GoogleIconSvg';
import { useTranslation } from 'react-i18next'; // NEW: Import useTranslation hook for i18n
import { Trans } from 'react-i18next'; // NEW: Import Trans component for handling HTML tags

const GoogleAuthButton: React.FC = () => {
    const dispatch = useAppDispatch();
    const theme = useTheme(); // NEW: Get access to the current theme object
    const { t } = useTranslation(); // NEW: Initialize translation hook

    const handleGoogleLogin = () => {
        // These should be in your .env file
        const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || 'YOUR_GOOGLE_CLIENT_ID';
        const REDIRECT_URI = `${window.location.origin}/auth/callback`;

        const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${GOOGLE_CLIENT_ID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=email profile openid&prompt=consent`;

        // Open a new popup window for Google authentication
        window.open(authUrl, '_blank', 'width=600,height=700,left=200,top=100');
    };

    useEffect(() => {
        // Listener for messages from the popup window
        const handleMessage = (event: MessageEvent) => {
            // Security check: ensure the message is from our own origin
            if (event.origin !== window.location.origin) {
                console.warn('Received message from untrusted origin:', event.origin);
                return;
            }

            const { type, code, error } = event.data;

            if (type === 'oauth_success' && code) {
                console.log('Received auth code from popup:', code);
                dispatch(googleLoginUser({ code, provider: 'google' }));
            } else if (type === 'oauth_error') {
                console.error('OAuth Error from popup:', error);
            }
        };

        window.addEventListener('message', handleMessage);

        // Cleanup the event listener when the component unmounts
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [dispatch]);

    return (
        <Button
            fullWidth
            variant="outlined"
            onClick={handleGoogleLogin}
            // UPDATED: sx prop is now a function to access the theme for dynamic styling
            sx={{
                mt: 1,
                mb: 1,
                color: 'text.primary',
                borderColor: 'grey.400',
                textTransform: 'none',
                fontWeight: 500,
                fontSize: '1rem',
                py: '6px',
                '&:hover': {
                    // FIX: Use a theme-aware background color for the hover state.
                    // In dark mode, use a standard semi-transparent white overlay.
                    // In light mode, use a light grey background.
                    // This ensures the text remains visible on hover in both themes.
                    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : theme.palette.grey[100],
                },
                // Ensure icon and text are spaced correctly
                justifyContent: 'center',
                alignItems: 'center',
                gap: 1.5,
            }}
        >
            <GoogleIconSvg />
            {t('google_login_button')} {/* NEW: Use translation key for button text */}
        </Button>
    );
};

export default GoogleAuthButton;